import { PRICING_BULLETS } from "@/data/service";

export function Pricing() {
  return (
    <section className="px-4 py-6">
      <div className="rounded-xl border border-[var(--line)] bg-paper-warm px-5 py-6">
        <p className="kicker mb-4">收费说明 · TRANSPARENT</p>
        <div className="mb-3 rounded-md border border-[var(--line)] bg-paper p-[18px]">
          <p className="mb-1.5 text-xs font-semibold tracking-wide text-ink-500">
            管家服务费
          </p>
          <p className="flex items-baseline gap-2">
            <span className="text-4xl font-bold tracking-tight text-coral-700">
              S$ 500
            </span>
            <span className="text-[13px] text-ink-600">/ 一整学年</span>
          </p>
        </div>
        <ul className="flex flex-col gap-1.5">
          {PRICING_BULLETS.map((t) => (
            <li
              key={t}
              className="flex items-start gap-2 text-[13px] leading-snug text-ink-700"
            >
              <span className="mt-0.5 font-mono text-[10px] text-forest-700">·</span>
              <span>{t}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
